import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useQuery } from 'hooks/useQuery'

import { UserType } from 'types/user'

import { useClientSubscriptions } from './useClientSubscriptions'
import { useMultipleUsers } from './useMultipleUsers'

/**
 * Fetches the trainers to show Group chat rooms for.
 * This includes the current user if they have an Group set up.
 * @returns An array of users to show Group chat rooms for.
 */
export const useChatRoomTrainers = () => {
  const { data: currentUser } = useCurrentUser()
  const { data: subscriptions } = useClientSubscriptions({
    userId: currentUser?.id,
  })

  const { data: subscribedTrainers } = useMultipleUsers({
    userIds: subscriptions?.map((sub) => sub.program.trainer.id ?? '') ?? [],
  })

  const {
    meta,
    data: userGroup,
    isLoading: isUserGroupLoading,
  } = useGroup({ userId: currentUser?.id })
  const { hasSetupGroup } = meta
  const showUserProgram = !isUserGroupLoading && userGroup && hasSetupGroup

  return useQuery<Array<UserType | null> | undefined>(
    ['chatRoomTrainers'],
    () => {
      let returnCoaches = subscribedTrainers
      if (currentUser && showUserProgram) {
        returnCoaches = [currentUser, ...subscribedTrainers]
      }

      return returnCoaches
    },
    {
      enabled: !!currentUser?.id,
    },
  )
}
